// ══════════════════════════════════════════════
//  广告平台字典（共享数据源）
//  一级 = code（后台自定义，全局唯一，创建后不可改）
//  二级 = 别名（App 上报的原始名称，仅名称，全局唯一）
//  下游「广告平台」下拉只读启用的一级 code
// ══════════════════════════════════════════════

// TODO: 联调时替换为接口数据
export const MOCK_AD_PLATFORMS = [
    {
        code: 'max',
        website: 'https://www.applovin.com',
        status: 1,
        sort: 1,
        aliases: [
            { id: 'al_max_1', name: 'applovin', status: 1, sort: 1 },
            { id: 'al_max_2', name: 'AppLovin', status: 1, sort: 2 },
        ],
    },
    {
        code: 'taku',
        website: 'https://www.taku.com',
        status: 1,
        sort: 2,
        aliases: [
            { id: 'al_taku_1', name: 'taku', status: 1, sort: 1 },
        ],
    },
    {
        code: 'fengchuan',
        website: 'https://www.fengchuan.com',
        status: 1,
        sort: 3,
        aliases: [
            { id: 'al_fc_1', name: 'fengchuan', status: 1, sort: 1 },
            { id: 'al_fc_2', name: 'fc', status: 1, sort: 2 },
        ],
    },
    {
        code: 'AdMob',
        website: 'https://admob.google.com',
        status: 1,
        sort: 4,
        aliases: [
            { id: 'al_admob_1', name: 'AdMob', status: 1, sort: 1 },
        ],
    },
    {
        code: 'gdt',
        website: 'https://developers.e.qq.com',
        status: 0,
        sort: 5,
        aliases: [
            { id: 'al_gdt_1', name: 'gdt', status: 1, sort: 1 },
        ],
    },
];

// 启用的一级平台（供下游「广告平台」下拉使用）
export const getEnabledPrimaryPlatforms = () =>
    MOCK_AD_PLATFORMS
        .filter((p) => p.status === 1)
        .sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0))
        .map((p) => ({ value: p.code, label: p.code }));
